import { render, staticRenderFns } from "./finx-power-bi-layout.vue?vue&type=template&id=0e145295"
import script from "./finx-power-bi-layout.vue?vue&type=script&lang=ts"
export * from "./finx-power-bi-layout.vue?vue&type=script&lang=ts"
import style0 from "./finx-power-bi-layout.vue?vue&type=style&index=0&id=0e145295&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports